// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import DPAttentionMsgTemplate from '@front/templates/DPAttentionMsgTemplate.html';
import { DynPropertyControl } from '../elements/DynPropertyControl';
export class DPAttentionMsg extends DynPropertyControl {
    constructor() {
        super();
    }
    localize() {
        const locKey = this.get('dp.localizationKey');
        void this.set('messageBoxText', Resources.getResource(locKey));
    }
}
DynPropertyControl.extendWith(DPAttentionMsg, {
    template: DPAttentionMsgTemplate,
    data: function () {
        return {
            messageBoxText: ''
        };
    }
});
